// extracted by mini-css-extract-plugin
export default {"icones":"Footer_icones__lgr5j"};